import { isNative } from '@/composables/capacitor.js'
import { Browser } from '@capacitor/browser'
import { Filesystem, Directory } from '@capacitor/filesystem'
import { FileViewer } from '@capacitor/file-viewer'
import { Capacitor } from '@capacitor/core'

export async function useExternalLink(url) {
  console.log('Trying to open', url)
  if (!isNative()) {
    window.open(url, '_blank')
  } else {
    if (url.startsWith('blob:')) {
      await openLocalBlobOnNative(url)

    } else
      return Browser.open({ url })

  }
}

async function openLocalBlobOnNative(blobUri) {
  try {
    const response = await fetch(blobUri)
    const blob = await response.blob()
    const base64Data = await convertBlobToBase64(blob)
    const fileName = `temp_file_${Date.now()}.${getFileExtension(blob.type)}`
    const savedFilePath = await saveFile(base64Data.split(',')[1], fileName)
    await FileViewer.openDocumentFromLocalPath({ path: savedFilePath })
  } catch (error) {
    console.error('Error opening file:', error)
  }
}

async function saveFile(base64Data, fileName) {
  const result = await Filesystem.writeFile({
    path: fileName,
    data: base64Data,
    directory: Directory.Cache,
  })

  if (Capacitor.getPlatform() === 'android') {
    return result.uri
  }

  return result.uri || `${Capacitor.convertFileSrc(result.uri)}`
}

function convertBlobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

function getFileExtension(mimeType) {
  const extensions = {
    'application/pdf': 'pdf',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'text/plain': 'txt',
    'video/x-msvideo': 'avi',
    'video/mp4': 'mp4',
  }
  return extensions[mimeType] || 'bin'
}
